var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Scan Berkas RM")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("h4", { staticClass: "mb-3" }, [_vm._v("Pencarian Data")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-3" }, [
        _c("div", { staticClass: "mb-3 row" }, [
          _c(
            "label",
            {
              staticClass: "col-sm-4 col-form-label text-end",
              attrs: { for: "tanggal_dari" },
            },
            [_vm._v("Tanggal Daftar")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-8" }, [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.tanggal_dari,
                    expression: "filter.tanggal_dari",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "date",
                  name: "tanggal_dari",
                  id: "tanggal_dari",
                },
                domProps: { value: _vm.filter.tanggal_dari },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.filter, "tanggal_dari", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "input-group-text" }, [_vm._v("s/d")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.tanggal_sampai,
                    expression: "filter.tanggal_sampai",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "date",
                  name: "tanggal_sampai",
                  id: "tanggal_sampai",
                },
                domProps: { value: _vm.filter.tanggal_sampai },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.filter, "tanggal_sampai", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-3" }, [
        _c("div", { staticClass: "mb-3 row" }, [
          _c(
            "label",
            {
              staticClass: "col-sm-4 col-form-label text-end",
              attrs: { for: "tanggal_sampai" },
            },
            [_vm._v("Status Scan")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-8 mt-2" }, [
            _c("div", { staticClass: "form-check form-check-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.status_scan,
                    expression: "filter.status_scan",
                  },
                ],
                staticClass: "form-check-input",
                attrs: {
                  name: "status_scan",
                  type: "radio",
                  id: "inlineCheckbox1",
                  value: "semua",
                },
                domProps: { checked: _vm._q(_vm.filter.status_scan, "semua") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.filter, "status_scan", "semua")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "inlineCheckbox1" },
                },
                [_vm._v("Semua")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-check form-check-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.status_scan,
                    expression: "filter.status_scan",
                  },
                ],
                staticClass: "form-check-input",
                attrs: {
                  name: "status_scan",
                  type: "radio",
                  id: "inlineCheckbox2",
                  value: "sudah",
                },
                domProps: { checked: _vm._q(_vm.filter.status_scan, "sudah") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.filter, "status_scan", "sudah")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "inlineCheckbox2" },
                },
                [_vm._v("Sudah")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-check form-check-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.status_scan,
                    expression: "filter.status_scan",
                  },
                ],
                staticClass: "form-check-input",
                attrs: {
                  name: "status_scan",
                  type: "radio",
                  id: "inlineCheckbox3",
                  value: "belum",
                },
                domProps: { checked: _vm._q(_vm.filter.status_scan, "belum") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.filter, "status_scan", "belum")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "inlineCheckbox3" },
                },
                [_vm._v("Belum")]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-4" }, [
        _c("div", { staticClass: "mb-3 row" }, [
          _c(
            "label",
            {
              staticClass: "col-sm-6 col-form-label text-end",
              attrs: { for: "search" },
            },
            [_vm._v("No. RM/Nama/NIK/No Kartu BPJS")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter.search,
                  expression: "filter.search",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text", name: "search", id: "search" },
              domProps: { value: _vm.filter.search },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filter, "search", $event.target.value)
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c("div", { staticClass: "mb-3" }, [
          _c("div", { staticClass: "col-sm-8 text-end" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                on: { click: _vm.resetFilters },
              },
              [_c("i", { staticClass: "fa fa-refresh" }), _vm._v(" Reset")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: { click: _vm.getAllPasien },
              },
              [_c("i", { staticClass: "fa fa-search" }), _vm._v(" Cari")]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("h4", { staticClass: "mb-3" }, [_vm._v("Data Pasien")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("table", { staticClass: "table table-striped" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.master_pasiens, function (pasien) {
                return _c("tr", { key: pasien.Medrec }, [
                  _c("td"),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(pasien.Medrec))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(pasien.Firstname))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(pasien.Bod))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(pasien.NoIden))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(pasien.AskesNo))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(pasien.tgl_daftar))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          attrs: { to: `/scan-berkas-rm/${pasien.Medrec}` },
                        },
                        [_vm._v("Detail")]
                      ),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("Pagination", {
            key: _vm.filter.total,
            attrs: {
              totalItems: _vm.filter.total,
              itemsPerPage: _vm.filter.per_page,
              maxPageButtons: 10,
              page: _vm.filter.page,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.filter, "page", $event)
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th", [_vm._v("No Rekam Medis")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nama")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tanggal Lahir")]),
        _vm._v(" "),
        _c("th", [_vm._v("NIK")]),
        _vm._v(" "),
        _c("th", [_vm._v("No Kartu BPJS")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tanggal Daftar")]),
        _vm._v(" "),
        _c("th", [_vm._v("Aksi")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }